import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FORBIDDEN, INTERNAL_SERVER_ERROR, NOT_FOUND, UNAUTHORIZED } from 'http-status-codes';

import { httpErrorPages } from './enums/http-error-pages';
import { GlobalErrorHandlingComponent } from './global-error-handling.component';

const GlobalErrorHandlingRoutes: Routes = [
  { path: httpErrorPages.unauthorized.path, component: GlobalErrorHandlingComponent, data: { statusCode: UNAUTHORIZED } },
  { path: httpErrorPages.forbidden.path, component: GlobalErrorHandlingComponent, data: { statusCode: FORBIDDEN } },
  { path: httpErrorPages.notFound.path, component: GlobalErrorHandlingComponent, data: { statusCode: NOT_FOUND } },
  { path: httpErrorPages.internalServerError.path, component: GlobalErrorHandlingComponent, data: { statusCode: INTERNAL_SERVER_ERROR } },
  { path: httpErrorPages.otherError.path, component: GlobalErrorHandlingComponent },
  { path: '**', redirectTo: httpErrorPages.notFound.path }
];

@NgModule({
  imports: [
    RouterModule.forChild(GlobalErrorHandlingRoutes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class GlobalErrorHandlingRoutingModule {
}
